import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import EventsView from '../../features/events-view';
import { PrivatePage } from '../../components/private-page';

export type dictionary = {
  id: number;
  name: string;
};

export default function MyEventView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useState('');

  const backHandler = () => {
    navigate('/myevents');
  };

  return (
    <PrivatePage
      breadcrumb={[
        {
          label: 'Dashboard',
          href: 'dashboard'
        },
        {
          label: 'My events',
          href: 'myevents'
        },
        {
          label: 'Event details',
          href: `myeventview/${id}`
        }
      ]}
      pageTitle={pageTitle}>
      <EventsView
        id={id}
        onBackButtonClick={backHandler}
        setPageTitle={setPageTitle}
      />
    </PrivatePage>
  );
}
